import React, { ReactElement, ReactNode, useState } from 'react';
import { Box, Popover, Tooltip } from '@mui/material';

// Touch screens need an explicit tap target for information otherwise shown on hover.
export default function TapTooltip({
  mobile = false,
  title,
  children,
}: {
  mobile?: boolean;
  title: ReactNode;
  children: ReactElement;
}) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  if (!mobile) return <Tooltip title={title}>{children}</Tooltip>;
  return (
    <>
      {React.cloneElement(children, {
        onClick: (event: React.MouseEvent<HTMLElement>) =>
          setAnchor(event.currentTarget),
        'aria-expanded': !!anchor,
      })}
      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Box sx={{ p: 2, maxWidth: '85vw' }}>{title}</Box>
      </Popover>
    </>
  );
}
